import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NavService } from '../providers/nav.service';
import { Router } from '@angular/router';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
// import { Cookie } from 'ng2-cookies/ng2-cookies';
// import { AuthService } from 'angularx-social-login';
import { ApiService } from '../providers/api.service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from '../providers/common.service';
// import { UpperCasePipe } from '@angular/common';
// import { elementEventFullName } from '@angular/compiler/src/view_compiler/view_compiler';
// import { stringify } from 'querystring';
import { isEmptyObject } from 'jquery';
// import { DeviceDetectorService } from 'ngx-device-detector';
import { NgxSpinnerService } from 'ngx-spinner';
import { headerMenu, platformList, sportList } from '../shared.service';


// declare const gapi: any;
@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.css']
})
export class SettingsComponent implements OnInit, OnDestroy {
  @ViewChild('myForgotForm', { static: false }) myForgotForm;
  public auth2: any;
  profileForm: FormGroup;
  forgotForm: FormGroup;
  submitted = false;
  forgotemail = '';
  submittedForgot = false;
  profileDet: any = {};
  loginUserDetails: any = {};
  sport: any;
  platform: any;
  notificationList = [
    { id: 1, text: 'My player alerts', isSelected: true },
    { id: 2, text: 'All player alerts', isSelected: true },
  ];
  // tempNotificaction: any = [];

  // subTotal: any = 0;
  // mainTotal: any = 0;

  masterMonthlySelected: boolean;
  masterAnnualSelected: boolean;

  paymentDetails: any = [];
  deviceInfo = null;

  // ReferralCode = '';
  // subscriptionItems: any = { items: [] };
  // userSubscriptionList: any = {};
  // checkSubscirptionPlanlist: any;

  isChecked: any;
  platformList = platformList;
  sportList = sportList;

  upgradeDisplay = 'none';
  activeMenu = headerMenu.plan;
  packageDetails = [];
  selectedPackageTotal = 0;

  constructor(
    private navService: NavService,
    private formbuilder: FormBuilder,
    private api: ApiService,
    private SpinnerService: NgxSpinnerService,
    private toastr: ToastrService,
    private commonService: CommonService,
    private route: Router,
    // private deviceService: DeviceDetectorService,
    // private authService: AuthService,
  ) {
    // this.loginUserDetails = JSON.parse(localStorage.getItem("loginDetails"));
    // if (this.loginUserDetails && this.loginUserDetails.data) {
    //   this.profileDet = this.loginUserDetails.data.userDetails;
    //   this.platform = this.loginUserDetails.data.userDetails.default_platform_id;
    //   this.sport = this.loginUserDetails.data.userDetails.default_sport_id;
    //   this.packageDetails = this.loginUserDetails.data.packageList;
    // }

    this.loginUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (this.loginUserDetails && this.loginUserDetails.userDetails) {
      this.profileDet = this.loginUserDetails.userDetails;
      this.platform = this.profileDet.default_platform_id;
      this.sport = this.profileDet.default_sport_id;
      this.packageDetails = JSON.parse(localStorage.getItem('PackageDetails'));
    }

    this.masterMonthlySelected = false;
    this.masterAnnualSelected = false;
    if (!isEmptyObject(this.packageDetails)) {
      this.packageDetails.forEach(element => {
        element.isMothlySelected = false;
        element.isAnnualSelected = false;
      });
    }
  }

  handler: any = null;
  ngOnInit() {
    this.profileForm = this.formbuilder.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      email: ['', Validators.required],
      currentPassword: ['', ''],
      newPassword: ['', ''],
      confirmPassword: ['', ''],
      fd_username: ['', ''],
      dk_username: ['', '']
    },
      {
        validators: this.mustMatch('newPassword', 'confirmPassword')
      }
    );

    this.forgotForm = this.formbuilder.group({
      email: ['', [Validators.required, Validators.email]]
    });

    this.loadStripe();
  }

  mustMatch(controlName: string, matchingControlName: string) {
    return (formGroup: FormGroup) => {
      const control = formGroup.controls[controlName];
      const matchingControl = formGroup.controls[matchingControlName];

      if (matchingControl.errors && !matchingControl.errors.mustMatch) {
        return;
      }

      if (control.value !== matchingControl.value) {
        matchingControl.setErrors({ mustMatch: true });
      } else {
        matchingControl.setErrors(null);
      }
    };
  }

  get f() {
    return this.profileForm.controls;
  }

  get f2() {
    return this.forgotForm.controls;
  }

  loadStripe() {
    if (!window.document.getElementById('stripe-script')) {
      const s = window.document.createElement('script');
      s.id = 'stripe-script';
      s.type = 'text/javascript';
      s.src = 'https://checkout.stripe.com/checkout.js';
      s.onload = () => {
        this.handler = (window as any).StripeCheckout.configure({
          // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',
          key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
          locale: 'auto',
          token(token: any) {
            // You can access the token ID with `token.id`.
            // Get the token ID to your server-side code for use.
            // console.log(token);
            alert('Payment Success!!');
          }
        });
      };
      window.document.body.appendChild(s);
    }

  }


  onForgotPopup() {
    this.forgotemail = '';
    this.myForgotForm.resetForm();
    this.submittedForgot = false;
    // console.log('event fired');
  }

  onForgotSubmit() {
    this.submittedForgot = true;
    if (this.forgotForm.valid) {
      // console.log('forgot form valid');
    } else {
      // console.log('forgot form invalid');
    }
  }


  onLogout() {
    // this.fbLogout();
    localStorage.clear();
    // this.authService.signOut(true);
    this.navService.changeNav('');
  }

  onDeactiveAccount() {
    // localStorage.clear();
    // this.navService.changeNav('SignUp');
    const data = {
      user_id: this.loginUserDetails.user_id
    };
    this.SpinnerService.show();
    this.api.deactiveAccount(data).subscribe(item => {
      this.SpinnerService.hide();
      if (item && item.code == 100) {
        localStorage.clear();
        this.navService.changeNav('SignUp');
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.toastr.error('Somthing went wrong', 'warning');
    });
  }

  onProfileUpdate() {
    this.submitted = true;
    if (this.profileForm.valid) {
      // console.log('form valid');
      let sport, platform;
      const tempUserDetails = JSON.parse(localStorage.getItem('userDetails'));
      if (tempUserDetails && tempUserDetails.userDetails) {
        sport = tempUserDetails.userDetails.default_sport_id;
        platform = tempUserDetails.userDetails.default_platform_id;
      }

      const updationData = {
        first_name: this.profileDet.first_name,
        last_name: this.profileDet.last_name,
        email: this.profileDet.email,
        current_password: this.profileDet.oldPassword,
        new_password: this.profileDet.newPassword,
        user_id: this.loginUserDetails.user_id,
        default_sport_id: sport,
        default_platform_id: platform,
        fd_username:this.profileDet.fd_username,
        dk_username:this.profileDet.dk_username
      };

      this.updatePersonalDetails(updationData, 'ProfileUpdate');
    } else {
      // console.log('form invalid');
    }
  }

  onDefaultsSportPlatformUpdatebtn() {

    let fname, lname, email;
    const tempUserDetails = JSON.parse(localStorage.getItem('userDetails'));
    if (tempUserDetails && tempUserDetails.userDetails) {
      fname = tempUserDetails.userDetails.first_name;
      lname = tempUserDetails.userDetails.last_name;
      email = tempUserDetails.userDetails.email;
    }

    const updationData = {
      first_name: fname,
      last_name: lname,
      email,
      user_id: this.loginUserDetails.user_id,
      default_sport_id: this.sport,
      default_platform_id: this.platform,
      current_password: '',
      new_password: '',
    };

    this.updatePersonalDetails(updationData, 'DefaultSportUpdate');
  }

  updatePersonalDetails(item, type) {
    this.SpinnerService.show();
    this.api.updatePlatformSport(item).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        if (type == 'ProfileUpdate') {
          this.submitted = false;
          this.profileDet.oldPassword = '';
          this.profileDet.newPassword = '';
          this.profileDet.confirmPassword = '';
        }
        this.toastr.success('Profile updated successfully', 'Success');
        this.commonService.getProfileDetails(this.loginUserDetails.user_id);
      } else {
        this.toastr.warning(data.message || 'Somthing went wrong', 'warning');
      }
    }, (err) => {
      this.SpinnerService.hide();
      this.toastr.error('Somthing went wrong', 'warning');
    });
  }

  changePackage(item, isFrom) {
    if (item.package_id == 4) {
      const tmp = JSON.parse(JSON.stringify(item));
      this.packageDetails.forEach(element => {
        element.isMonthlyCheck = false;
        element.isAnnualCheck = false;
      });

      if (isFrom == 1) {
        if (tmp.isMonthlyCheck) { item.isMonthlyCheck = true; }
      } else {
        if (tmp.isAnnualCheck) { item.isAnnualCheck = true; }
      }
    } else {
      const tmp = this.packageDetails.find(m => m.package_id == 4);
      if (!tmp.isMonthlyCheck && !tmp.isAnnualCheck) {
        if (isFrom == 1) {
          if (item.isMonthlyCheck) { item.isAnnualCheck = false; }
        } else {
          if (item.isAnnualCheck) { item.isMonthlyCheck = false; }
        }
      } else {
        tmp.isAnnualCheck = false;
        tmp.isMonthlyCheck = false;
      }
    }
  }

  onUpgrade() {
    this.packageDetails.forEach(element => {
      if (element.isMonthlyCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.monthly_price; }
      if (element.isAnnualCheck) { this.selectedPackageTotal = this.selectedPackageTotal + element.annual_price; }
    });

    if (this.selectedPackageTotal > 0) {
      const _self = this;
      const handler = (window as any).StripeCheckout.configure({
        // key: 'pk_test_aeUUjYYcx4XNfKVW60pmHTtI',  //dummy key
        key: 'pk_test_51HbLWrAFcfh8Mf7ZnkhqV6q4vyKYV0bDFZC2OJ4q8IUOiT0IC4wfCTTdxB9ePnqO7jsNw5TwieJUpwqzQwMoqD3C00EzoZpAoL',
        locale: 'auto',
        token(token: any) {
          // console.log(token);
          _self.insertPaymentDetails(token.id, token.email);
        }
      });
      handler.open({
        name: 'Chalk Faders',
        // description: '2 widgets',
        amount: this.selectedPackageTotal * 100,
        email: this.loginUserDetails.userDetails.email || ''
      });
    } else {
      this.toastr.error('Select at least one package', 'Pick a new plan');
      return;
    }
  }

  insertPaymentDetails(token, email) {
    const subscriptionItems: any = { items: [] };

    this.packageDetails.forEach(element => {
      const tempPlan: any = {};
      if (element.isAnnualCheck) {
        tempPlan.amount = element.annual_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'year';
        subscriptionItems.items.push(tempPlan);
      } else if (element.isMonthlyCheck) {
        tempPlan.amount = element.monthly_price;
        tempPlan.package_id = element.package_id;
        tempPlan.plan = 'month';
        subscriptionItems.items.push(tempPlan);
      }
    });

    const tempData: any = {};

    tempData.device_token = '-';
    tempData.device_type = '3';
    tempData.token = token;
    tempData.user_id = this.loginUserDetails.user_id;
    tempData.referral_user_id = '';
    tempData.promo_code = ''; // this.ReferralCode
    tempData.email = email;
    tempData.name = email;
    tempData.items = JSON.stringify(subscriptionItems);

    this.SpinnerService.show();
    this.api.paymentDetails(tempData).subscribe(data => {
      this.SpinnerService.hide();
      if (data && data.code == 100) {
        this.activeMenu = 4;
        localStorage.setItem('userSubscriptionList', JSON.stringify(data.data.userSubscriptionList));
        this.toastr.success('Payment Success', 'success');
      } else {
        this.toastr.warning('Somthing went wrong', 'Warning');
      }
    }, (err) => {
      this.SpinnerService.hide();
      // console.log(err);
    });
  }

  ngOnDestroy() {
    const currentUrl = this.route.url;
    this.navService.changeNavHeaderActive(currentUrl);
  }

  openModalDialog() {
    this.packageDetails = JSON.parse(localStorage.getItem('PackageDetails'));
    if (this.packageDetails && this.packageDetails.length > 0) {
      this.packageDetails.forEach(element => {
        element.isMonthlyCheck = false;
        element.isAnnualCheck = false;
      });
    }
    this.upgradeDisplay = 'block';
  }

  closeModalDialog() {
    this.activeMenu = 3;
    this.upgradeDisplay = 'none';
  }

}
